import React, { useEffect, useRef, useState } from "react";
import { Accordion, Tab, Tabs } from "react-bootstrap";
import { IMAGE_BASE_URL } from "../../../constants/configuration";
import { Link } from "react-router-dom";
import * as MainTab from "@radix-ui/react-tabs";
import { useSelector } from "react-redux";
import { searchData } from "../../../redux/commonReducer";

export default function Itinerary({ details, path }) {
  const data = useSelector(searchData);
  const accordionRefs = useRef([]);
  const [activeKey, setActiveKey] = useState(null);

  const handleAccordionClick = (i, ele) => {
    setActiveKey(activeKey === i ? null : i);

    setTimeout(() => {
      if (accordionRefs.current[i]) {
        const yOffset = -200;
        const y = accordionRefs.current[i].getBoundingClientRect().top + window.pageYOffset + yOffset;
        
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    }, 300);
  };

  const activity_attraction = details?.activity_attraction?.itinerary;

  return (
    <div className="itinerary">
      <div className="container">
        <h2 className="title">ITINERARY</h2>
        <img
          src={`${IMAGE_BASE_URL}${path}/${details?.main_map}`}
          alt={details?.main_map_alt}
          className="w-100 main"
        />
        <div className="trip_schedules">
          <Accordion activeKey={activeKey}>
            {details?.itinerary?.map((ele, i) => {
              return (
                <Accordion.Item
                  key={i}
                  eventKey={i}
                  ref={el => accordionRefs.current[i] = el}
                >
                  <Accordion.Header
                    onClick={() => handleAccordionClick(i, ele)}
                  >
                    Day {i + 1} :{ele?.title}
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="collapse__content">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: ele?.description,
                        }}
                      ></p>
                      <Tabs id="controlled-tab-example" className="mb-3">
                        {ele?.attraction?.length ? (
                          <Tab eventKey="home" title="Attractions">
                            <div className="attraction bg-transparent pb-0 pt-3">
                              <div className="container">
                                <div className="row">
                                  {activity_attraction?.[i]?.attraction?.map((ele, i) => {
                                    return (
                                      <div className="col-md-3" key={i}>
                                        <Link
                                          to={`/attraction-details/${ele?.handle_key}`}
                                        >
                                          <div className="atraction">
                                            <div className="image">
                                              <img
                                                src={`${IMAGE_BASE_URL}attraction/${ele?.image}`}
                                                alt={ele.image_alt}
                                                className="w-100"
                                              />
                                            </div>
                                            <div className="contents">
                                              <h3>{ele?.title}</h3>
                                              <p
                                                className="attract"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    ele?.short_description,
                                                }}
                                              ></p>
                                            </div>
                                          </div>
                                        </Link>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </Tab>
                        ) : (
                          <></>
                        )}
                        {ele?.activity?.length ? (
                          <Tab eventKey="profile" title="Activities">
                            <div className="attraction bg-transparent pb-0 pt-3">
                              <div className="container">
                                <div className="row">
                                  {activity_attraction?.[i]?.activity?.map((ele, i) => {
                                    return (
                                      <div className="col-md-3" key={i}>
                                        <Link
                                          to={`/activity-details/${ele?.handle_key}`}
                                        >
                                          <div className="atraction">
                                            <div className="image">
                                              <img
                                                src={`${IMAGE_BASE_URL}activity/${ele?.image}`}
                                                alt={ele.image_alt}
                                                className="w-100"
                                              />
                                            </div>
                                            <div className="contents">
                                              <h3>{ele?.title}</h3>
                                              <p className="itineraryDurationIcon">
                                                <img
                                                  src="/assets/img/icons/clock.svg"
                                                  height={17}
                                                  alt=""
                                                />
                                                Duration {ele?.duration} hours
                                              </p>
                                            </div>
                                          </div>
                                        </Link>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </Tab>
                        ) : (
                          <></>
                        )}
                        {!ele?.map_image ? (
                          <></>
                        ) : (
                          <Tab eventKey="contact" title="View Map">
                            <img
                              src={`${IMAGE_BASE_URL}${"package"}/${ele?.map_image
                                }`}
                              alt={ele?.map_image_alt}
                              className="w-100 itinerary__map"
                            // style={{ height: "400px", objectFit: "contain" }}
                            />
                          </Tab>
                        )}
                      </Tabs>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
